export default "__VITE_ASSET__bd5b5fb5__"